import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import Select from 'react-select';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { editStoreRole, storeRoles } from '../../../../../../queries';

import { Content, Button, DeleteButton } from './styles';
import { SelectLabel, Label, Input } from '../../../../../../assets/styles';

class EditRoleFormModal extends Component {
  state = {
    options: [
      { value: '001', label: 'Dono' },
      { value: '002', label: 'Gerente' },
      { value: '003', label: 'Funcionário' },
    ],
    defaultRole: '',
    id: '',
    role: '',
    name: '',
    email: '',
    submitLoading: false,
    deleteLoading: false,
  }

  componentDidMount = () => {
    if (this.props.userType === 'manager') {
      this.setState({ options: [{ value: '003', label: 'Funcionário' }] });
    }
  }

  editRoleFormModal = ({
    id,
    role,
    name,
    email,
  }) => {
    let defaultRole;

    if (role === 'Dono') defaultRole = [{ value: '001', label: role }];
    if (role === 'Gerente') defaultRole = [{ value: '002', label: role }];
    if (role === 'Funcionário') defaultRole = [{ value: '003', label: role }];

    this.setState({
      id,
      role,
      name,
      email,
      defaultRole,
      submitLoading: false,
      deleteLoading: false,
    });
  }

  handleSubmit = async () => {
    this.setState({ submitLoading: true });

    const { id, role } = this.state;
    let roleType;

    if (role === 'Dono') roleType = 'owner';
    if (role === 'Gerente') roleType = 'manager';
    if (role === 'Funcionário') roleType = 'employee';

    this.props
      .editStoreRole({
        variables: {
          storeId: this.props.storeId,
          userId: id,
          roleType,
        },
        refetchQueries: [{ query: storeRoles, variables: { storeId: this.props.storeId } }],
      })
      .then(async () => {
        this.setState({ submitLoading: false });
        this.props.close();
        this.props.alert.success('Informações salvas com sucesso');
      });
  }

  deleteRole = () => {
    this.setState({ deleteLoading: true });

    const { id } = this.state;

    this.props
      .deleteStoreRole({
        variables: {
          storeId: this.props.storeId,
          userId: id,
        },
        refetchQueries: [{ query: storeRoles, variables: { storeId: this.props.storeId } }],
      })
      .then(async () => {
        this.setState({ deleteLoading: false });
        this.props.close();
        this.props.alert.success('Função administrativa removida com sucesso');
      });
  }

  handleSelectChange = (field, value) => {
    this.setState({ [field]: value });
  }

  render() {
    const {
      options,
      defaultRole,
      role,
      name,
      email,
      submitLoading,
      deleteLoading,
    } = this.state;

    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.roleFormModal = ref; }}
      >
        <Content>
          <h2>Editar função administrativa</h2>
          <Label>
            <p className="fieldName">Cargo</p>
            <SelectLabel>
              <Select
                className="input"
                classNamePrefix="input"
                placeholder="Selecione"
                defaultValue={defaultRole}
                onChange={value => this.handleSelectChange('role', value.label)}
                options={options}
                isSearchable={false}
                isClearable={false}
              />
            </SelectLabel>
            {role === 'Dono' && (
              <p className="inputMessage alertMessage">
                <span className="errorMessage">Pode gerenciar todos os aspectos da Loja.</span>
                {' Pode: fazer a gestão dos pedidos, cadastrar materiais, ver detalhes financeiros, visualizar e responder avaliações, alterar informações da loja e adicionar funções administrativas.'}
              </p>
            )}
            {role === 'Gerente' && <p className="inputMessage alertMessage">Pode fazer a gestão dos pedidos, cadastrar materiais, ver detalhes de faturamento, visualizar e responder avaliações, alterar informações da loja e adicionar funcionários.</p>}
            {role === 'Funcionário' && <p className="inputMessage alertMessage">Pode fazer a gestão dos pedidos, cadastrar materiais, visualizar e responder avaliações.</p>}
          </Label>
          <Label>
            <p className="fieldName">Nome</p>
            <Input
              readOnly
              type="text"
              name="name"
              value={name}
            />
          </Label>
          <Label>
            <p className="fieldName">E-mail</p>
            <Input
              readOnly
              type="text"
              name="email"
              value={email}
            />
          </Label>
          <Button type="submit" disabled={submitLoading} onClick={this.handleSubmit}>
            {!submitLoading ? (
              'Salvar'
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={submitLoading}
              />
            )}
          </Button>
          <DeleteButton type="submit" disabled={deleteLoading} delete onClick={this.deleteRole}>
            {!deleteLoading ? (
              'Excluir'
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#E50000"
                loading={deleteLoading}
              />
            )}
          </DeleteButton>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(editStoreRole, { name: 'editStoreRole', withRef: true }),
)(EditRoleFormModal);
